import get from 'lodash-es/get'
import omit from 'lodash-es/omit'
import set from 'lodash-es/set'

import { DEFAULT_DRAFTS } from '../../constants/draft'
import { LOCAL_STORAGE_DRAFTS_KEY } from '../../constants/storage'
import { isDevelopmentEnvironment } from '../../utils/common'
import { AsyncStorage } from '../../utils/storage'

export class DraftsLocalStorage {
  /**
   * @type AsyncStorage
   */
  #storage

  constructor() {
    this.#storage = new AsyncStorage(localStorage)
  }

  /**
   * @template {*} TValue
   *
   * @param {number} userId
   * @param {string} draftId
   * @param {TValue} defaultValue
   *
   * @returns {Promise<TValue>}
   */
  getItem(userId, draftId, defaultValue) {
    return (
      this.#storage
        .getItem(LOCAL_STORAGE_DRAFTS_KEY, DEFAULT_DRAFTS)
        .then(drafts => get(drafts, [userId, draftId], defaultValue))
        /*
        Sometimes, due to poisoning of the global `EMPTY_OBJECT` object,
        a saved draft contains a nested tree with the user ID as the key.
        This may cause unexpected results, need to remove it here.
        */
        .then(draft => draft && omit(draft, userId))
    )
  }

  /**
   * @template {*} TValue
   *
   * @param {number} userId
   * @param {string} draftId
   * @param {TValue} draft
   *
   * @returns {Promise<TValue>}
   */
  setItem(userId, draftId, draft) {
    return this.#storage
      .getItem(LOCAL_STORAGE_DRAFTS_KEY, DEFAULT_DRAFTS)
      .then(drafts => set({ ...drafts }, [userId, draftId], draft ?? undefined))
      .then(drafts => this.#storage.setItem(LOCAL_STORAGE_DRAFTS_KEY, drafts))
      .then(drafts => {
        if (isDevelopmentEnvironment()) {
          console.info('Draft saved', userId, draftId, draft)
        }

        return get(drafts, [userId, draftId], null)
      })
  }
}
